import { Dialog, Drawer } from "@mui/material";
import useWindowSize from "./Hooks/useWindowSize";

function DialogWrapper({ open, height, width, component, closeDialog }) {
  const { isMobileView } = useWindowSize();
  return isMobileView() ? (
    <Drawer
      open={open}
      onClose={() => {
        closeDialog();
      }}
      anchor="bottom"
      PaperProps={{
        sx: {
          borderRadius: "24px 24px 0 0 ",
          height: height ? height : "auto",
        },
      }}
    >
      {component}
    </Drawer>
  ) : (
    <Dialog
      open={open}
      onClose={() => {
        closeDialog();
      }}
      PaperProps={{
        sx: {
          width: width ? width : "70vw",
          maxWidth: "unset",
          height: height ? height : "auto",
        },
      }}
    >
      {component}
    </Dialog>
  );
}

export default DialogWrapper;
